import * as React from 'react';

import {NavIconLogoutIcon} from 'shells/icon/navigation/nav-icon-logout';

import {MenuItem} from './menu-item';

import styles from './user-menu-popover.module.css';

type Props = {
    onClose: () => void;
};

export function Logout(props: Props) {
    return (
        <button
            onClick={() => {
                window.location.href = '/auth/logout';
                props.onClose();
            }}
            tabIndex={0}
            className={styles['menu-item-button']}
        >
            <MenuItem icon={NavIconLogoutIcon} text='Log out' />
        </button>
    );
}
